import { getConstants } from '~/utils/constants';

export default defineNuxtRouteMiddleware(async (to) => {
  const authStore = useAuthStore();
  const { loggedUser } = useAuthStore();
  const { PUBLIC_PATHS } = getConstants();
  const token = useCookie('Authorization').value;

  if (!loggedUser && !token) {
    const basePath = to.path.split('/')[1];

    if (!PUBLIC_PATHS.includes(basePath)) {
      return navigateTo('/login');
    } else if (basePath === 'products') {
      const offerPath = to.fullPath.replace('?', '&').replace('/products/', '/signup-offer?link_id=');
      return navigateTo(offerPath);
    }
  } else if (token && !loggedUser) {
    await authStore.me();
  }
});
